"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearSchema = void 0;
exports.YearSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/date-year.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Year",
    "description": "Store a year",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:date-year"
            ]
        },
        "year": {
            "type": "integer",
            "maximum": 2100,
            "minimum": 1700
        }
    },
    "required": [
        "type",
        "year"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS15ZWFyLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvZGF0ZS15ZWFyLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLFVBQVUsR0FBRztJQUN4QixLQUFLLEVBQUUsa0VBQWtFO0lBQ3pFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLE1BQU07SUFDZixhQUFhLEVBQUUsY0FBYztJQUM3QixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixzQkFBc0I7YUFDdkI7U0FDRjtRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLFNBQVMsRUFBRSxJQUFJO1lBQ2YsU0FBUyxFQUFFLElBQUk7U0FDaEI7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=